import { useEffect, useState } from "react";
import { useCachedResource } from "../hooks/useCachedResource";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuCard } from "../components/neu/Neu";
import { SalesShell } from "../features/sales/SalesShell";
import { DocRow } from "../features/sales/DocRow";
import { DocDetail } from "../features/sales/DocDetail";
import { DocActions } from "../features/sales/DocActions";
import { deliveryAction, getDoc, listDocs, orderAction, quotationAction } from "../api/sales";

const RUN = { quotation: quotationAction, order: orderAction, delivery: deliveryAction };

// قائمة مستندات نوع واحد + تفاصيل + أفعال الحالة (تُستخدم للعروض والأوامر والتسليمات).
export default function SalesDocsPage({ docType }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState(false);

  const { data, reload: load } = useCachedResource(
    `sales-docs-${docType}`, () => listDocs({ doc_type: docType }).then((d) => d.items || []), [docType]);
  const rows = data || [];

  useEffect(() => { setOpen(null); }, [docType]);

  const run = async (action) => {
    setBusy(true);
    try {
      const body = action === "reject" || action === "hold" || action === "cancel"
        ? { reason: t("sales.defaultReason") } : {};
      await RUN[docType](open.id, action, body);
      toast.success(t("sales.actionDone"));
      setOpen(await getDoc(open.id));
      load();
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <SalesShell titleKey={`${docType}s`}>
      <div className="grid gap-2" data-testid={`sales-${docType}-list`}>
        {rows.map((doc) => (
          <DocRow key={doc.id} doc={doc} onOpen={async (row) => setOpen(await getDoc(row.id))} />
        ))}
        {!rows.length ? (
          <p className="text-sm text-muted-foreground" data-testid={`no-${docType}s`}>
            {t("sales.noDocs")}
          </p>
        ) : null}
      </div>

      {open ? (
        <NeuCard className="grid gap-4 p-5" data-testid="sales-doc-panel">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-sm font-bold">
              {open.number || t("sales.noNumber")} · {open.party?.legal_name}
            </p>
            <DocActions doc={open} onRun={run} busy={busy} />
          </div>
          <DocDetail doc={open} />
        </NeuCard>
      ) : null}
    </SalesShell>
  );
}
